/*
 * 用户登录相关api
 */

import { post, get, put, del } from 'api/http'
import storage from 'src/unit/storage'

export default {
    // 修改实名认证
    setUserIdcard(data) {
        return post('/wx/user/updateIdCard', data, 'javaHost')
    },

    // 获取实名认证详情
    getUserIdcardDetail(data) {
        return get('/wx/user/getIdcard', data, 'javaHost')
    },

    // 识别身份证图片文字
    recognizeIdcard(data) {
        return post('/app/user/recognize_idcard', data)
    },

    // 用户-获取工作信息
    getWorkMsg(data) {
        return get('/wx/user/workInfo', data, 'javaHost')
    },

    // 提交资格认证
    putUserCert(data) {
        return post('/wx/user/savePermit', data, 'javaHost')
    },

    // 获取资格证件详情
    getCertDetail(data) {
        return get('/wx/user/permitInfo', data, 'javaHost')
    },

    // // 拒绝人员记录列表
    // getRejectLog(data) {
    //     return get('/staff/reject_log', data)
    // },
    // // 离职人员记录列表
    // getDismissLog(data) {
    //     return get('/staff/dismiss_log', data)
    // },
    // // 添加人员
    // addTeamMember(data) {
    //     return post('/staff/add', data)
    // },
    // 添加项目人员
    // addProjectMember(data) {
    //     return post('/contract_staff/add ', data)
    // },
    // // 删除人员
    // deleteTeamMember(data) {
    //     return post('/staff/delete', data)
    // },
    // // 移除人员
    // removeTeamMember(data) {
    //     return post('/contract_staff/delete', data)
    // },
    // // 离职登记
    // setDismiss(data) {
    //     return post('/staff/dismiss', data)
    // },
    // // 审核人员
    // verifyTeamMember(data) {
    //     return post('/staff/approve', data)
    // },

    // 意见反馈
    addFeedback(data) {
        return post('/opinion/submit', data, 'javaHost')
    },

    // // 获取用户角色
    // getUserRoles(data) {
    //     return get('/sys_user/role_list', data)
    // },

    // // 用户角色切换
    // changeRole(data) {
    //     return post('/sys_user/update/main_role', data)
    // },

    // // 离开团队
    // leaveTeam(data) {
    //     return post('staff/leave_bm', data)
    // },

    // // 取消授权
    // cancelAuth(data) {
    //     return post('bm/cancel_auth', data)
    // }
}



// WEBPACK FOOTER //
// ./src/api/modules/ems/userCenter.js